import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ActivityCard from './ActivityCard';
import { getLegislations, getTranslatedText } from '../pages/utils_v2/kumuHelper';
import { QuestionPhase } from '../constants';
import { useTranslation, Trans } from 'react-i18next';

export default function ActivityPicker({ categories, elements, connections, setLegislation, setQuestionPhase, activities, setActivities }) {

    const { t, i18n } = useTranslation('translation');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleContinue = () => {
        if (activities.length !== 0) {
            setLegislation(getLegislations(activities, connections, elements));
            setQuestionPhase(QuestionPhase.LEGISLATIONS);
        }
    };

    return (
        <Box mt={4}>
            <p>
                <Trans
                    i18nKey="The Mine Permit Navigator related some typical activities that occur as part of mining projects to the categories you've selected. Please click on each activity that you think you will undertake as part of your mining project. By selecting CONTINUE, you can learn more about the federal legislation that may regulate these activities and the approvals that might be required."
                    components={{
                        a: <a href="mailto:minepermitnavigator-navigateurdepermisminier@nrcan-rncan.gc.ca"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('mailto:minepermitnavigator-navigateurdepermisminier@nrcan-rncan.gc.ca');
                            }} />
                    }}
                />
            </p>

            {categories.map(category => (
                // Replaced ul/li with Box to remove bullet indentation on mobile
                <Box key={category.name} mt={4}>
                    <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                        {getTranslatedText(i18n.language, category.name)}
                    </p>
                    <Divider
                        variant='fullWidth'
                        sx={{ borderBottomWidth: '2px', backgroundColor: '#AF3C43', mb: 1 }}
                    />
                    <Grid container direction='row' spacing={isMobile ? 1 : 2}>
                        {category.activities
                            .slice()
                            .sort((a, b) => {
                                const labelA = getTranslatedText(i18n.language, a.name).toLowerCase();
                                const labelB = getTranslatedText(i18n.language, b.name).toLowerCase();
                                return labelA.localeCompare(labelB);
                            })
                            .map(activity => (
                                <Grid
                                    item
                                    // 2 cards per row on mobile, 3 on tablet, 4 on desktop
                                    xs={6}
                                    sm={4}
                                    md={4}
                                    mt={isMobile ? 1 : 2}
                                    key={activity.id}
                                >
                                    <ActivityCard
                                        activity={activity}
                                        activities={activities}
                                        setActivities={setActivities}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Box>
            ))}

            <Box sx={{ width: '100%', mt: 3 }}>
                <button
                    className="btn btn-primary"
                    style={{
                        width: isMobile ? '100%' : 'auto',
                        minHeight: '44px',
                    }}
                    onClick={handleContinue}
                >
                    {t('Continue')}
                </button>
            </Box>
        </Box>
    );
}